<template>
    <div>
        <resources-base-table
            :inputs="inputs"
            :headers="headers"
            :items="items"
            :editedItem="editedItem"
            :defaultItem="defaultItem"
            :modelService="modelService"
            @edit="onEditItem"
            @closeDialog="onCloseDialog"
        >
            <template v-slot:form="{ localEditedItem }">
                <span v-for="field in inputs" :key="field.value">
                    <v-text-field v-model="localEditedItem[field.value]" :label="field.text"></v-text-field>
                </span>
                <v-select
                    v-model="pais"
                    :items="paises"
                    item-text="pais"
                    item-value="id"
                    label="Pais del Lugar"
                    return-object
                    single-line
                ></v-select>
                <v-autocomplete
                    v-if="pais"
                    v-model="localEditedItem.lugarId"
                    :loading="loadingLugares"
                    :items="lugares"
                    :search-input.sync="lugaresSearch"
                    item-value="id"
                    item-text="lugar"
                    flat
                    hide-no-data
                    hide-details
                    label="Lugar"
                ></v-autocomplete>
                <template v-if="localEditedItem.id">
                    <h4>Imágenes</h4>
                    <v-btn :disabled="processingImage" color="primary" @click="addImage(localEditedItem)">
                        Agregar imagen
                    </v-btn>
                    <div v-for="(imagen, index) in localEditedItem.sedeImagenes" :key="index">
                        <span class="index-imagen">{{ index + 1 }}. {{ index == 0 ? "Imagen portada" : "" }}</span>
                        <div class="imagen-form-row">
                            <v-text-field class="imagen-input" v-model="imagen.url" label="URL imagen"></v-text-field>
                            <v-btn
                                :disabled="processingImage"
                                small
                                color="danger"
                                @click="removeImage(localEditedItem, index)"
                            >
                                X
                            </v-btn>
                        </div>
                    </div>
                </template>
            </template>

            <template v-slot:actions="{ item }">
                <router-link :to="{ name: 'SedesCarreraSedes', params: { id: item.id } }">
                    <v-icon small>carreras</v-icon>
                </router-link>
            </template>
        </resources-base-table>
        <v-dialog v-model="imagesDialog" max-width="700px">
            <v-card v-if="sedeImagenesItem">
                <v-card-title>
                    <span class="headline">Imágenes</span>
                </v-card-title>
                <v-card-text>
                    <v-container></v-container>
                </v-card-text>

                <v-card-actions></v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    SedesService,
    SedeImagenesService,
    PaisesService,
    LugaresService
} from "../../../services/carreras-api.service"
export default {
    data() {
        return {
            modelService: SedesService,
            imagesDialog: false,
            sedeImagenesItem: null,
            processingImage: false,
            inputs: [
                {
                    sortable: false,
                    text: "Nombre",
                    value: "sede"
                },
                {
                    sortable: false,
                    text: "Descripción",
                    value: "descripcion"
                },
                {
                    sortable: false,
                    text: "Direccion",
                    value: "direccion"
                },
                {
                    sortable: false,
                    text: "Latitud",
                    value: "latitud"
                },
                {
                    sortable: false,
                    text: "Longitud",
                    value: "longitud"
                },

                {
                    sortable: false,
                    text: "URL video",
                    value: "urlVideo"
                }
            ],
            headers: [
                {
                    sortable: false,
                    text: "Nombre",
                    value: "sede"
                },
                {
                    sortable: false,
                    text: "Descripción",
                    value: "descripcion"
                },
                {
                    sortable: false,
                    text: "Direccion",
                    value: "direccion"
                },
                {
                    sortable: false,
                    text: "Latitud",
                    value: "latitud"
                },
                {
                    sortable: false,
                    text: "Longitud",
                    value: "longitud"
                },
                {
                    sortable: false,
                    text: "URL video",
                    value: "urlVideo"
                },
                { text: "Acciones", value: "action", sortable: false }
            ],
            editedItem: {
                sede: "",
                direccion: "",
                latitud: "",
                longitud: "",
                descripcion: "",
                urlVideo: "",
                universidadId: this.$route.params.id
            },
            defaultItem: {
                sede: "",
                direccion: "",
                latitud: "",
                longitud: "",
                descripcion: "",
                urlVideo: "",
                universidadId: this.$route.params.id
            },
            paises: [],
            pais: null,
            loadingLugares: false,
            lugares: [],
            lugaresSearch: "",
            timeoutLugaresSearch: null
        }
    },
    props: ["items"],
    methods: {
        editImagenes(item) {
            this.sedeImagenesItem = { ...item, sedeImagenes: [...item.sedeImagenes] }
            this.imagesDialog = true
        },
        addImage(item) {
            if (item.sedeImagenes.length < 6) {
                this.processingImage = true
                SedeImagenesService.create({ sedeId: item.id, url: "" }).then(sedeImagen => {
                    item.sedeImagenes.push(sedeImagen)
                    this.processingImage = false
                })
            }
        },
        removeImage(item, index) {
            if (!item.sedeImagenes[index].id) {
                item.sedeImagenes.splice(index, 1)
            } else {
                this.processingImage = true
                SedeImagenesService.destroy(item.sedeImagenes[index].id).then(() => {
                    item.sedeImagenes.splice(index, 1)
                    this.processingImage = false
                })
            }
        },
        onEditItem(item) {
            if (item.lugarId) {
                LugaresService.where({ lugar: { id: item.lugarId } }).then(lugares => {
                    this.lugares = lugares
                    const lugar = lugares[0]

                    this.pais = this.paises.find(pais => pais.id == lugar.paisId)
                })
            }
        },
        onCloseDialog() {
            this.lugares = []
            this.pais = null
        }
    },
    created() {
        PaisesService.where().then(paises => {
            this.paises = paises
        })
    },
    watch: {
        lugaresSearch(val) {
            if (!val) return

            if (this.timeoutLugaresSearch) {
                clearTimeout(this.timeoutLugaresSearch)
            }

            this.timeoutLugaresSearch = setTimeout(() => {
                this.loadingLugares = true

                LugaresService.where({ lugar: { like: { lugar: `%${val}%` }, paisId: this.pais.id }, per: 100 })
                    .then(lugares => {
                        this.lugares = lugares
                    })
                    .finally(() => (this.loadingLugares = false))
            }, 500)
        }
    }
}
</script>
<style scoped>
.imagen-form-row {
    display: flex;
    flex-flow: row;
    align-items: center;
}
.imagen-input {
    padding-right: 1em;
}
</style>
